<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item> 立项评审 </el-breadcrumb-item>
      <el-breadcrumb-item>用户评定</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 申报书列表 -->
      <el-table :data="projcetDistribute" style="width: 100%">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="pname" label="名称" width="280"></el-table-column>
        <el-table-column prop="leader_name" label="作者" width="180"></el-table-column>
        <el-table-column label="查看" width="80">
          <template slot-scope="scope">
            <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
              @click="showInfoForm(scope.row)">
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="评审" width="150">
          <template slot-scope="scope">
            <el-button size="mini" :plain="true" type="primary" @click="assessButton(scope.row)">评审
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 申报书查看 -->
    <el-card v-show="infoFormVisible" id="id-el-card-info">
      <el-row>
        <el-col :span="24">
          <div class="header-edit">申报书详情</div>
        </el-col>
      </el-row>
      <el-card>
        <el-col class="el-col-addForm">
          <span> 课题类别：</span>
          <el-input :disabled="true" v-model="editForm.category_direction"></el-input>
          <span> 课题名称：</span>
          <el-input :disabled="true" v-model="editForm.name"></el-input>
        </el-col>
      </el-card>

      <!-- 文件列表 -->
      <div class="div-file">
        <el-table :data="fileList" style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
          <el-table-column prop="name" label="文件名" width="300"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="150">
            <template slot-scope="scope">
              {{ scope.row.create_time | fmtdate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <!-- <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                  @click="downloadFile(scope.row)"></el-button> -->
              <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                @click="getPdfCode(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 预期成果形式 -->
      <el-card>
        <el-row class="el-row-detail">
          <el-col :span="8"><span> 预期成果形式：</span>
            <el-input :disabled="true" v-model="editForm.result_type"></el-input>
          </el-col>
          <el-col :span="8"><span> 字数：</span>
            <el-input :disabled="true" v-model="editForm.total_words"></el-input>
          </el-col>
          <el-col :span="8"><span> 预计完成时间：</span>
            <el-input :disabled="true" v-model="editForm.complete_time"></el-input>
          </el-col>
        </el-row>
      </el-card>
      <!-- 课题研究计划 -->
      <el-card>
        <div>课题研究计划</div>
        <quill-editor :disabled="true" v-model="editForm.content" :options="editorOption" class="editor"></quill-editor>
      </el-card>
      <!-- 预算 -->
      <el-card>
        <h3>课题预算</h3>
        <div class="div-budget">
          <div>
            <table>
              <tr>
                <td>序号</td>
                <td>预算科目名称</td>
                <td>预算金额（万元）</td>
                <td>测算依据（另附页说明）</td>
              </tr>
              <tr>
                <td>1</td>
                <td>经费总额</td>
                <td>
                  <el-input v-model="budget.f1"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s1"></el-input>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>一、直接费用</td>
                <td>
                  <el-input v-model="budget.f2"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s2"></el-input>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>1.设备费</td>
                <td>
                  <el-input v-model="budget.f3"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s3"></el-input>
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>（1）购置设备费</td>
                <td>
                  <el-input v-model="budget.f4"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s4"></el-input>
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>（2）试制设备费</td>
                <td>
                  <el-input v-model="budget.f5"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s5"></el-input>
                </td>
              </tr>
              <tr>
                <td>6</td>
                <td>（3）设备改造与租赁费</td>
                <td>
                  <el-input v-model="budget.f6"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s6"></el-input>
                </td>
              </tr>
              <tr>
                <td>7</td>
                <td>2.材料费</td>
                <td>
                  <el-input v-model="budget.f7"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s7"></el-input>
                </td>
              </tr>
              <tr>
                <td>8</td>
                <td>3.测试化验加工费</td>
                <td>
                  <el-input v-model="budget.f8"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s8"></el-input>
                </td>
              </tr>
              <tr>
                <td>9</td>
                <td>4.差旅费</td>
                <td>
                  <el-input v-model="budget.f9"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s9"></el-input>
                </td>
              </tr>
              <tr>
                <td>10</td>
                <td>其中：市内交通费</td>
                <td>
                  <el-input v-model="budget.f10"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s10"></el-input>
                </td>
              </tr>
              <tr>
                <td>11</td>
                <td>5.会议费</td>
                <td>
                  <el-input v-model="budget.f11"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s11"></el-input>
                </td>
              </tr>
              <tr>
                <td>12</td>
                <td>6.出版/印刷/文献/信息传播/知识产权事务费</td>
                <td>
                  <el-input v-model="budget.f12"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s12"></el-input>
                </td>
              </tr>
              <tr>
                <td>13</td>
                <td>7.劳务费</td>
                <td>
                  <el-input v-model="budget.f13"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s13"></el-input>
                </td>
              </tr>
              <tr>
                <td>14</td>
                <td>8.专家咨询费</td>
                <td>
                  <el-input v-model="budget.f14"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s14"></el-input>
                </td>
              </tr>
              <tr>
                <td>15</td>
                <td>二、间接经费（不得超过课题经费总额的10%）</td>
                <td>
                  <el-input v-model="budget.f15"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s15"></el-input>
                </td>
              </tr>
              <tr>
                <td>16</td>
                <td>1.管理费用</td>
                <td>
                  <el-input v-model="budget.f16"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s16"></el-input>
                </td>
              </tr>
              <tr>
                <td>17</td>
                <td>2.其他具体说明</td>
                <td>
                  <el-input v-model="budget.f17"></el-input>
                </td>
                <td>
                  <el-input maxlength="12" v-model="budget.s17"></el-input>
                </td>
              </tr>
            </table>

            <div style="margin-top: 20px;">
              <span style="font-size: 20px;">测算依据说明:</span>
            </div>
            <quill-editor v-model="budget.reason" :options="editorOption" class="editor"></quill-editor>
          </div>
        </div>
      </el-card>
    </el-card>

    <!-- 评审对话框 -->
    <el-dialog title="课题评审" :visible.sync="assessDialogVisible">
      <h4>课题类别：{{ projectAssess.category }}</h4>
      <h4>课题方向：{{ projectAssess.category_direction }}</h4>
      <h4>课题名称：{{ projectAssess.pname }}</h4>
      <h4>作者：{{ projectAssess.leader_name }}</h4>
      <div>
        <span>请填写对该项目的意见和建议：</span>
        <quill-editor v-model="assessSuggestion" :options="editorOption" class="assess-uggestion">
        </quill-editor>
      </div>
      <el-button type="primary" @click="assess()">提交</el-button>
    </el-dialog>

    <!-- pdf查看 -->
    <el-dialog :visible.sync="pdfVisible" width="80%" :style="{ top: '-150px' }">
      <div class="onlineHelp cg-box">
        <div class="tools">
          <el-button type="mini" @click="zoomIn">放大</el-button>
          <el-button type="mini" @click="zoomOut">缩小</el-button>
        </div>
        <iframe :src="pdfSrc" width="100%" :height="iframeHeight" style="border:none;"></iframe>
      </div>
    </el-dialog>

  </div>
</template>

<script>
//富文本
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import * as Quill from "quill";
import { quillEditor } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);

//下载
import fileDownload from "js-file-download";
// pdf预览
import pdf from "vue-pdf";

export default {
  components: {
    quillEditor, pdf
  },
  data() {
    return {
      //pdf显示
      pdfSrc: '', // PDF 文件的 URL
      pdfVisible: false, // 控制 PDF 弹窗显示
      iframeHeight: '800px', // iframe 的高度，可以通过 zoomIn 和 zoomOut 来调整

      editContent: "",
      pid: "",
      userid: "",
      projcetDistribute: [],
      projectInfo: [],
      projectCategorys: [],
      selectValue: "", //课题类型下拉框显示的值
      infoFormVisible: false,
      editForm: {}, //编辑申报书
      budget: {},
      fileList: [], //附件列表
      // qill-editor
      editorOption: {},
      projectAssess: {}, //评审按钮传入的待评审课题
      //评审对话框
      assessDialogVisible: false,

      // 教练评审意见
      assessSuggestion: "",
      assessDate: ""
    };
  },

  created() {
    this.userid = localStorage.getItem("userid");
    this.username = localStorage.getItem("username");
    this.getProjectInfo();
    let d = new Date();
    this.assessDate =
      d.getFullYear() + "年" + (d.getMonth() + 1) + "月" + d.getDate() + "日";

  },

  methods: {
    // 获取课题信息
    async getProjectInfo() {
      const res = await this.axios.get(
        `/projectDistribute/?status=评审&coach=${this.userid}`
      );
      if (res.status === 200) {
        this.projcetDistribute = res.data.results;
      } else {
        this.$message.warning("错误");
      }
    },

    // 获取附件列表
    async getFileList(pid) {
      const res = await this.axios.get(`/fileList/?pid=${pid}`);
      if (res.status === 200) {
        this.fileList = res.data.results;
      } else {
        this.$message.warning("获取文件列表错误");
      }
    },

    // 显示查看申报书卡片（）
    async showInfoForm(item) {
      this.infoFormVisible = true;
      let res = await this.axios.get("/projectInfo/?pid=" + item.pid);
      this.editForm = res.data.results[0];
      this.budget = this.editForm.budget;
      this.getFileList(item.pid);

      setTimeout(() => {
        document.getElementById("id-el-card-info").scrollIntoView({
          behavior: "smooth"
        });
      }, 500);
    },

    // 下载文件
    downloadFile(item) {
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`;
      let params = {
        path: item.path,
        name: item.name
      };
      this.axios
        .post(url, params, {
          responseType: "arraybuffer"
        })
        .then(res => {
          fileDownload(res.data, item.name);
        });
    },

    //评审按钮
    assessButton(item) {
      this.assessDialogVisible = !this.assessDialogVisible;
      this.projectAssess = item;
    },

    // 计算评审结果
    async assess() {
      // this.$message.success(`评审总分为：${score}分！`)
      let res = await this.axios.get(
        "/projectAssess/?pid=" + this.projectAssess.pid
      );
      res = res.data.results;

      // 写ProjectAssess评审结果表
      if (res[0]) {
        // 有记录,
        let data = res[0];
        // 将评审结果添加到数组
        data.coach_result = {
          coach: this.userid,
          cname: this.username,
          assessSuggestion: this.assessSuggestion,
          assessDate: this.assessDate
        };

        let resPut = await this.axios.put(`/projectAssess/${data.id}/`, data);
        // 删除projectDistribute
        let resGet = await this.axios.get(
          "/projectDistribute/?status=评审&pid=" +
          this.projectAssess.pid +
          "&coach=" +
          this.userid
        );
        resGet = resGet.data.results[0];
        let resDel = await this.axios.delete(`/projectDistribute/${resGet.id}`);
        // console.log('del1:' + resDel.status)
        if (resPut.status == 200) {
          this.$message.success("评审完成");
        } else {
          this.$message.error("评审失败");
        }
      } else {
        // 无记录，post
        let data = {
          pid: this.projectAssess.pid,
          pname: this.projectAssess.pname,
          leader: this.projectAssess.leader,
          leader_name: this.projectAssess.leader_name,
          category: this.projectAssess.category,
          category_direction: this.projectAssess.category_direction,
          status: "未立项",
          coach_result: {
            coach: this.userid,
            cname: this.username,
            assessSuggestion: this.assessSuggestion,
            assessDate: this.assessDate
          }
        };
        let resPost = await this.axios.post("/projectAssess/", data);
        // 删除projectDistribute
        let resGet = await this.axios.get(
          "/projectDistribute/?status=评审&pid=" +
          this.projectAssess.pid +
          "&coach=" +
          this.userid
        );
        resGet = resGet.data.results[0];
        let resDel = await this.axios.delete(`/projectDistribute/${resGet.id}`);
        // console.log('del:' + resDel.status)
        if (resPost.status == 201) {
          this.$message.success("评审成功！");
        } else {
          this.$message.error("评审失败");
        }
      }
      // 对话框不可见，初始化课题列表
      this.assessDialogVisible = false;
      this.getProjectInfo();
    },

    // pdf预览
    // 获取 PDF 文件
    getPdfCode(item) {
      this.pdfVisible = true;  // 显示弹窗
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`;
      let params = {
        path: item.path,
        name: item.name
      };

      this.axios({
        method: 'post',
        url: url,
        data: params,
        responseType: 'blob' // 设置响应的数据类型为 Blob
      }).then(response => {
        // 检查是否为 PDF 文件
        const file = response.data;
        const blob = new Blob([file], { type: 'application/pdf' }); // 确保 MIME 类型是 PDF
        this.pdfSrc = URL.createObjectURL(blob); // 创建可供 iframe 使用的 URL
      }).catch(error => {
        console.error("加载 PDF 文件失败:", error);
      });
    },

    // 将 Blob 转换为 URL
    createPdfObjectURL(file) {
      return URL.createObjectURL(file); // 使用 URL.createObjectURL 创建可访问的文件 URL
    },
    // 放大 PDF
    zoomIn() {
      let currentHeight = parseInt(this.iframeHeight);
      this.iframeHeight = `${currentHeight + 100}px`; // 每次放大100px
    },
    // 缩小 PDF
    zoomOut() {
      let currentHeight = parseInt(this.iframeHeight);
      this.iframeHeight = `${Math.max(currentHeight - 100, 300)}px`; // 最小缩小到300px
    },
  }
};
</script>

<style lang="less">
.el-card {
  margin-top: 15px;
}

.header-edit {
  font-size: 18px;
  text-align: left;
  margin-bottom: 10px;
}

.el-col-user-add {
  display: flex;
}

.user-search {
  width: 420px;
  margin-right: 10px;
}

.el-col-addForm {
  display: flex;
  margin-bottom: 10px;

  span {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  .el-input {
    width: 400px;
  }
}

.el-card-leader {
  .div-leader {
    font-size: 16px;
    margin-bottom: 15px;
  }
}

.member {
  font-size: 16px;
  margin-bottom: 15px;
}

.el-row-detail {
  width: 1020px;

  .el-col {
    display: flex;

    span {
      display: flex;
      align-items: center;
      margin-left: 10px;
    }

    .el-input {
      width: 200px;
    }
  }
}

.editor {
  margin-top: 15px;
  width: 790px;
}

.ql-editor {
  min-height: 200px;
}

.div-upload {
  width: 500px;
  padding-top: 10px;
}

.div-add {
  margin-top: 20px;
  display: flex;
  justify-content: end;
}

.div-file {
  margin-top: 15px;
}

.el-dialog {
  width: 900px;

  .divScore {
    font-size: 20px;
  }

  .el-radio {
    margin-left: 20px;
    width: 70px;
  }

  .divSuggestion {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .divAgree {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .el-button {
    margin-top: 30px;
  }
}

.assess-uggestion {
  margin-top: 20px;
  width: 800px;
}

.div-budget {
  justify-content: start;
}
</style>



// WEBPACK FOOTER //
// src/components/project/ProjectAssessCoach.vue